module.exports = __webpack_public_path__ + "img/NarminOsman-TanhaHez.f6f7d084.jpg";